import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';

@Component({
  selector: 'app-feedback-process',
  templateUrl: './feedback-process.component.html',
  styleUrls: ['./feedback-process.component.scss']
})
export class FeedbackProcessComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;
  
  ngOnInit(): void {
  }

}
